export default __webpack_public_path__ + "static/media/35-Chiller.dc6c631f.jpeg";